<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data: function() {
    return {

    }
  },
  async created() {

  },
  async mounted() {
    this.$store.dispatch('auth/refresh')
    this.getDomain().then()
  },
  methods: {
    getDomain: async function() {
      const defaultImage = '/neo/BI/standard-withtext-contrast.png'
      const defaultImageSmall = '/neo/web/images/favicon.png'

      const result = await this.$API.user.domain()
      if (result.code === 0 && result.domain) {
        if (result.domain.design.logo) {
          this.$store.commit('layout/CHANGE_LOGO_IMAGE', result.domain.design.logo)
        } else {
          this.$store.commit('layout/CHANGE_LOGO_IMAGE', defaultImage)
        }

        if (result.domain.design.logoSmall) {
          this.$store.commit('layout/CHANGE_LOGO_IMAGE_SMALL', result.domain.design.logoSmall)
        } else {
          this.$store.commit('layout/CHANGE_LOGO_IMAGE_SMALL', defaultImageSmall)
        }
      } else {
        this.$store.commit('layout/CHANGE_LOGO_IMAGE', defaultImage)
        this.$store.commit('layout/CHANGE_LOGO_IMAGE_SMALL', defaultImageSmall)
      }
    }
  }
}
</script>
